import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import { buttonGuidePropTypes } from './ButtonGuidePropTypes';
import * as styles from './ButtonGuide.module.scss';
const ButtonGuide = ({
  label,
  onClick
}) => {
  if (!label) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root}`,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootIconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "calculator",
    classname: styles.rootIcon
  })), label);
};
export default ButtonGuide;